import React from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const ModalReporteServicio = ({
    isOpen,
    onClose,
    childComponent,
    fullscreen = false,
    container,
    showCloseButton = true,
    bodyClassName = "",
    keyboardEnabled = true,
}) => {
    const backdropStyle = 'static';
    const modalStyle = {};
    return (
        <Modal

            isOpen={isOpen}
            backdrop={backdropStyle}
            toggle={onClose}
            keyboard={keyboardEnabled}
            size={fullscreen ? undefined : 'lg'}
            zIndex={9999}
            style={modalStyle}
            centered={!fullscreen}
            fullscreen={fullscreen}
            container={container}
        >
            <ModalHeader toggle={showCloseButton ? onClose : undefined}></ModalHeader>
            <ModalBody className={bodyClassName}>
                {isOpen ? childComponent : null}
            </ModalBody>
        </Modal >
    )
}

export default ModalReporteServicio
